module.exports = "<div id=country_refer> <div data-bind=\"foreach: intinalList\" class=country-tabs> <a href=javascript:void(0) class=country-tabs-item data-bind=\"text: text,\n      click: function () {$parent.changeInitial(id)}, css: {'country-tabs-active': id == $parent.index()}\"></a> </div> <div class=clearfix></div> <div class=country-content> <ul data-bind=\"foreach: {data: model.rows(), as: 'row'}\"> <li> <a data-bind=\"text: row.ref('countryNameCn'), click: function () {$parent.chooseNode(row)}\" href=javascript:void(0)></a> </li> </ul> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/country/index.html
// module id = 226
// module chunks = 144